import { Button } from 'reactstrap'
import cn from 'classnames'
import { getPaymentOverdueDate } from 'utils/paymentService'
import s from './AddButton.scss'

const AddButton = ({ className, onClick, children, cy, simpleBtn, disabled = false }) => {
  const isVisible = !getPaymentOverdueDate()

  if (isVisible) {
    return (
      <Button
        data-cy={cy}
        className={cn({ [s.saveBtn]: !simpleBtn }, className)}
        onClick={onClick}
        disabled={disabled}
      >
        {children}
      </Button>
    )
  }

  return null
}

export default AddButton
